export const globalTranslateSignatureStatus = (status: string = ""): string => {
	const s = status.toLowerCase();
	if (s === "running") return "Em processo";
	if (s === "closed") return "Assinado";
	if (s === "canceled") return "Cancelado";
	if (s === "draft") return "Rascunho";
	if (s === "open") return "Aberto";
	return status;
};

export const globalTranslateSignatureDocumentStatus = (status: string = ""): string => {
	const s = (status ?? "").toString().trim().toLowerCase();
	if (!s) return "";

	if (s === "pending") return "Pendente";
	if (s === "created") return "Criado";
	if (s === "uploaded") return "Enviado";
	if (s === "processing") return "Processando";
	if (s === "issued") return "Emitido";
	if (s === "ready") return "Pronto";
	if (s === "signed") return "Assinado";
	if (s === "refused") return "Recusado";
	if (s === "rejected") return "Recusado";
	if (s === "canceled" || s === "cancelled") return "Cancelado";
	if (s === "expired") return "Expirado";
	if (s === "failed" || s === "error") return "Erro";
	if (s === "deleted" || s === "removed") return "Removido";

	return status;
};
